import Typography from '@mui/material/Typography';
import { Modal, Box } from '@mui/material';
import { useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import ExemptionForm from 'src/components/ExemptionForm';
import RemoveModal from 'src/components/modal/RemoveModal';
import ReviewContext from 'src/store/review-page-context';
import ModalStyle from 'src/components/modal/ModalStyle';
import { useAPI } from 'src/services/api';
import ToastContext from 'src/store/toast-context';

const ExemptionModal = () => {
  const { reviewInfo, exemptionModal } = useContext(ReviewContext);
  const api = useAPI();
  const { exemptionModalController } = exemptionModal;
  const { multipleAccts, associatedAcctInfo, ownerChg, reqExempt, busStatus } =
    reviewInfo?.review?.updatedInfo;

  const { handleError, success } = useContext(ToastContext);

  const removeExemption = async () => {
    try {
      await api.patch('/filing/removeTaxExemption', { reqExempt: 'N' });
      success('Removed Exemption');
      reviewInfo.setReview({
        ...reviewInfo?.review,
        updatedInfo: { ...reviewInfo?.review?.updatedInfo, reqExempt: 'N' },
      });
      exemptionModalController.closeModal();
    } catch (err) {
      handleError(err);
    }
  };

  const submitExemptionFormData = async (formData) => {
    try {
      const res = await api.patch('/filing/taxExemption', formData);
      reviewInfo.setReview({
        ...reviewInfo?.review,
        updatedInfo: { ...reviewInfo?.review?.updatedInfo, ...res.data },
      });

      exemptionModalController.closeModal();
    } catch (err) {
      handleError(err);
    }
  };

  return (
    <Modal
      keepMounted
      open={exemptionModalController.open}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
      sx={{
        display: 'flex',
        p: 1,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box component={'div'} sx={ModalStyle}>
        <Typography sx={{ display: 'flex', justifyContent: 'space-between' }} component="div">
          <Typography id="keep-mounted-modal-title" variant="h6" component="h2">
            Request Tax Exemption
          </Typography>
          <Typography
            data-cy="close-exemption"
            sx={{
              mt: '.25rem',
            }}
            onClick={exemptionModalController.closeModal}
          >
            <CloseIcon style={{ ml: '.5rem', color: 'grey', cursor: 'pointer' }} />
          </Typography>
        </Typography>
        <Typography sx={{ mb: '1rem' }}>
          Please answer the questions below to help us determine whether you meet the prerequisites
          for the Personal Property Tax Exemption. The Utah County Board of Equalization will make
          the final eligibility determination.
        </Typography>
        <ExemptionForm
          SecondaryBtn={
            reqExempt == 'Y' && <RemoveModal itemTitle="exemption" onRemove={removeExemption} />
          }
          onClose={exemptionModalController.closeModal}
          onSubmit={submitExemptionFormData}
          values={{ multipleAccts, associatedAcctInfo, ownerChg, reqExempt, busStatus }}
        ></ExemptionForm>
      </Box>
    </Modal>
  );
};
export default ExemptionModal;
